import { fetchCapabilities, fetchGuide, fetchGuides } from "@/lib/searchContent";

const CAP_HREF = {
  website: { href: "/capabilities#layer-website", label: "WEBSITE" },
  webdev: { href: "/capabilities#layer-webdev", label: "WEB DEVELOPMENT" },
  saas: { href: "/services/saas", label: "SaaS" },
  admin: { href: "/services/admin-cms", label: "ADMIN / CMS" },
  ai: { href: "/services/ai", label: "AI" },
  automation: { href: "/services/automation", label: "AUTOMATION" },
  search: { href: "/services/search", label: "SEARCH" },
};

export const AUTHORITY_SECTIONS = [
  { id: "aiDev", title: "AI / DEVELOPMENT" },
  { id: "webDesign", title: "WEB / DESIGN" },
  { id: "credentials", title: "CREDENTIALS" },
  { id: "experience", title: "EXPERIENCE" },
  { id: "ip", title: "INTELLECTUAL PROPERTY" },
  { id: "company", title: "COMPANY AUTHORITY" },
];

export async function loadPreviewCapabilities() {
  return fetchCapabilities();
}

export async function loadPreviewGuides(category = "") {
  return fetchGuides(category);
}

export async function loadPreviewGuide(slug) {
  return fetchGuide(slug);
}

export function capHref(id) {
  return CAP_HREF[id] || null;
}

export function groupAuthorityFacts(facts = []) {
  const grouped = {
    metric: [],
    aiDev: [],
    webDesign: [],
    credentials: [],
    experience: [],
    ip: [],
    company: [],
  };
  facts.forEach((row) => {
    const caps = row.related_capabilities || [];
    const group = row.public_group || "";
    if (group === "METRIC" || row.metric_value) {
      grouped.metric.push(row);
      return;
    }
    if (group === "COMPANY_AUTHORITY") {
      grouped.company.push(row);
      return;
    }
    if (group === "INTELLECTUAL_PROPERTY") {
      grouped.ip.push(row);
      return;
    }
    if (group === "EXPERIENCE") {
      grouped.experience.push(row);
      return;
    }
    if (caps.includes("website") && !caps.some((id) => ["webdev", "saas", "admin", "ai", "automation"].includes(id))) {
      grouped.webDesign.push(row);
      return;
    }
    if (group === "CREDENTIALS") {
      grouped.credentials.push(row);
      return;
    }
    grouped.aiDev.push(row);
  });
  return grouped;
}

export function factVerifyHref(row) {
  return row.external_verification_url || "";
}

const SECTION_HUE = {
  aiDev: "#f472b6",
  webDesign: "#38bdf8",
  credentials: "#facc15",
  experience: "#34d399",
  ip: "#a78bfa",
  company: "#60a5fa",
};

// One connected thread instead of a strip of interchangeable cards — every
// proof point (person, expertise, experience, credentials, IP, company) reads
// as a single trust story in order.
export function buildAuthoritySpine(data) {
  const grouped = groupAuthorityFacts(data?.authority?.facts || []);
  const person = (data?.authority?.people || [])[0];
  const items = [];

  if (person) {
    items.push({
      id: "person",
      hue: "#f4f4f5",
      title: "REPRESENTATIVE",
      lead: person.name,
      body: [person.role, person.summary].filter(Boolean).join(" — "),
    });
  }

  AUTHORITY_SECTIONS.forEach((section) => {
    const rows = grouped[section.id] || [];
    const lead = rows[0];
    items.push({
      id: section.id,
      hue: SECTION_HUE[section.id] || "#94a3b8",
      title: section.title,
      lead: lead ? lead.public_title : null,
      body: lead ? lead.public_description || lead.public_summary : "공개 승인된 항목이 아직 없습니다.",
      meta: rows.length > 1 ? `${rows.length} public records` : null,
      link: lead && factVerifyHref(lead) ? { href: factVerifyHref(lead), label: "외부 검증" } : null,
    });
  });

  return items;
}
